var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27823",
      "conversations-internal-schema": "static-1.13297",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8254",
      "hubspot-url-utils": "static-1.4296",
      "HubStyleTokens": "static-2.11710",
      "I18n": "static-7.1655",
      "jasmine-runner": "static-1.6677",
      "quartz": "static-1.7339",
      "react": "static-7.190",
      "reselect": "static-3.8",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.492",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6381",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3560",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18424",
      "cv-backend-services": "static-1.1590",
      "hub-http": "static-1.6442",
      "immutable": "static-2.83",
      "immutable-less": "static-1.4880",
      "quartz-config": "static-1.1117",
      "quartz-core": "static-1.6558",
      "transmute": "static-2.85",
      "HeadJS": "static-2.785",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8355",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3365",
      "msw": "static-1.39",
      "react-redux": "static-7.75",
      "redux": "static-4.16",
      "testing-library": "static-1.155",
      "foundations-theming": "static-1.4681",
      "i18n-data": "static-1.226",
      "metrics-js": "static-1.9866",
      "moment-timezone": "static-5.86",
      "react-utils": "static-2.5500",
      "jasmine": "static-4.4547",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3124",
      "react-aria": "static-1.69",
      "styled-components": "static-2.95",
      "UIComponents": "static-3.8656",
      "visitor-ui-component-library-icons": "static-1.6192",
      "bender-build-tools": "static-1.3347",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4886",
      "apollo-stack-hubspot": "static-3.89",
      "classnames": "static-2.10",
      "cssUtils": "static-1.861",
      "customer-data-objects": "static-1.7913",
      "customer-data-ui-utilities": "static-1.10055",
      "data-fetching-client": "static-1.9886",
      "FileManagerCore": "static-1.39811",
      "FileManagerLib": "static-1.39952",
      "foundations-assets": "static-1.5104",
      "graphql": "static-1.85",
      "hs-promise-utils": "static-1.5824",
      "hubspot-apollo-client": "static-1.5106",
      "icons": "static-2.672",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.108",
      "react-virtualized": "static-2.103",
      "rpc-client-utils": "static-1.4891",
      "salesImages": "static-1.530",
      "timezone-utils": "static-2.5475",
      "ui-gdpr-components": "static-1.10583",
      "ts-schema": "static-1.4238",
      "hs-locale-management": "static-1.240",
      "hs-lodash": "static-4.45",
      "immer": "static-1.94",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.863",
      "hubspotter-http": "static-1.4808",
      "mobile-manifest-mixins": "static-1.560",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.1014",
      "quartz-head": "static-1.1004",
      "quartz-i18n": "static-1.1014",
      "quartz-routing": "static-1.769",
      "quartz-test": "static-1.1014",
      "quartz-tracking": "static-1.718",
      "quick-fetch": "static-1.4076",
      "react-rhumb": "static-1.16935",
      "trellis-components": "static-1.2430",
      "ui-fonts": "static-1.972",
      "usage-tracker-container": "static-1.7576",
      "usage-tracker-core": "static-1.7436",
      "bend-plugin-foundations-components": "static-1.4624",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2397",
      "hs-story-utils": "static-1.9655",
      "react-create-root-preference": "static-1.55",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2411",
      "ui-images": "static-2.1222",
      "bend-plugin-foundations-theming": "static-1.3164",
      "foundations-theming-base": "static-1.3666",
      "stylex": "static-1.37",
      "HubStyle": "static-2.12017",
      "sassPrefix": "static-1.161",
      "inbound-db-properties-service-client": "static-1.4005",
      "property-translator": "static-1.5622",
      "react-dnd-compat": "static-1.4844",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9543",
      "breeze-artifacts-sdk": "static-1.121",
      "audio-components": "static-1.6248",
      "ContentUtils": "static-1.69012",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29705",
      "file-manager-components": "static-1.24312",
      "FileManagerImages": "static-1.37463",
      "foundations-components-legacy": "static-1.1380",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4380",
      "react-colorpicker": "static-2.10436",
      "redux-toolkit": "static-1.7",
      "ui-universal-auth": "static-1.9252",
      "urlinator": "static-1.4762",
      "usage-tracker": "static-1.7586",
      "video-components": "static-1.14007",
      "video-data-lib": "static-1.35663",
      "video-embed": "static-1.36497",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.565",
      "bend-plugin-chirp-manifest": "static-1.301",
      "chirp-fetch": "static-1.2116",
      "hub-http-shared-msw-handlers": "static-1.10494",
      "hubspotter-http-shared-msw-handlers": "static-1.10492",
      "usage-tracker-session-replay": "static-1.5272",
      "web-vitals": "static-1.9",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1184",
      "tanstack-virtual": "static-1.35",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.22537",
      "copilot-toolkit": "static-1.11707",
      "customer-data-objects-ui-components": "static-1.13260",
      "sanitize": "static-1.4705",
      "sanitize-text": "static-1.8377",
      "content-assistance-lib": "static-1.8106",
      "cms-field-types": "static-1.5043",
      "content-icons-ui": "static-1.2296",
      "integrations-lib": "static-1.16878",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.1524",
      "ui-addon-iframeable": "static-1.9305",
      "video-components-external": "static-1.12005",
      "unified-auth-core-lib": "static-1.1048",
      "social-insights-client-types": "static-1.22672",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4390",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5709",
      "magpie-types": "static-1.5169",
      "simple-logging-lib": "static-1.3278",
      "atom": "static-1.5305",
      "avatar-components": "static-1.2726",
      "reference-resolvers": "static-1.8411",
      "superstore": "static-1.4985",
      "ui-addon-video-player": "static-1.8935",
      "ui-coaching-tips": "static-1.29177",
      "flux-actions": "static-1.357",
      "frontend-preferences-client": "static-1.8157",
      "integrations-error-boundary-lib": "static-1.14293",
      "integrations-tracking-lib": "static-1.5837",
      "laboratory-lib": "static-3.7380",
      "native-integrations-shared-strings": "static-1.8006",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10594",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11375",
      "ui-shepherd-react": "static-3.10491",
      "unified-auth": "static-1.766",
      "breeze-engine-chat-components": "static-1.502",
      "breeze-engine-core": "static-1.802",
      "ably": "static-2.2",
      "highlight.js": "static-1.82",
      "navigation-messaging": "static-1.8014",
      "content-media-composition-data-lib": "static-1.13048",
      "content-media-compositions": "static-2.17055",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19310",
      "fsm": "static-1.3966",
      "reactive-lib": "static-1.949",
      "growth-onboarding-feedback-components": "static-1.6811",
      "universal-page-editor-lib": "static-1.3239",
      "foundations-components-test-utils": "static-1.5838",
      "adobe-sign-auth-lib": "static-1.314",
      "ads-unified-auth-lib": "static-1.891",
      "google-sheets-integration-lib": "static-1.892",
      "microsoft-drive-integration-lib": "static-1.1027",
      "surveymonkey-integration-lib": "static-1.337",
      "slack-ui-library": "static-1.10624",
      "js-cookie": "static-1.18",
      "react-dlb": "static-1.84",
      "crm-record-cards-service-types": "static-1.3739",
      "framework-data-schema-resolvers": "static-1.7122",
      "location-customization-utils-lib": "static-1.9952",
      "batch-promise": "static-1.1773",
      "conditional-properties-service-client": "static-1.3957",
      "crm-pipelines-api-client-types": "static-1.4294",
      "fdsr-migration-layer": "static-1.241",
      "framework-builder-read-service-client": "static-1.4166",
      "framework-data-schema-quick-fetch": "static-1.7027",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3851",
      "persist-promise": "static-1.3930"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27823",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13297",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8254",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4296",
      "HubStyleTokens": "/HubStyleTokens/static-2.11710",
      "I18n": "/I18n/static-7.1655",
      "jasmine-runner": "/jasmine-runner/static-1.6677",
      "quartz": "/quartz/static-1.7339",
      "react": "/react/static-7.190",
      "reselect": "/reselect/static-3.8",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.492",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6381",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3560",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18424",
      "cv-backend-services": "/cv-backend-services/static-1.1590",
      "hub-http": "/hub-http/static-1.6442",
      "immutable": "/immutable/static-2.83",
      "immutable-less": "/immutable-less/static-1.4880",
      "quartz-config": "/quartz-config/static-1.1117",
      "quartz-core": "/quartz-core/static-1.6558",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.785",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8355",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3365",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.75",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.155",
      "foundations-theming": "/foundations-theming/static-1.4681",
      "i18n-data": "/i18n-data/static-1.226",
      "metrics-js": "/metrics-js/static-1.9866",
      "moment-timezone": "/moment-timezone/static-5.86",
      "react-utils": "/react-utils/static-2.5500",
      "jasmine": "/jasmine/static-4.4547",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3124",
      "react-aria": "/react-aria/static-1.69",
      "styled-components": "/styled-components/static-2.95",
      "UIComponents": "/UIComponents/static-3.8656",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6192",
      "bender-build-tools": "/bender-build-tools/static-1.3347",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4886",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.861",
      "customer-data-objects": "/customer-data-objects/static-1.7913",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10055",
      "data-fetching-client": "/data-fetching-client/static-1.9886",
      "FileManagerCore": "/FileManagerCore/static-1.39811",
      "FileManagerLib": "/FileManagerLib/static-1.39952",
      "foundations-assets": "/foundations-assets/static-1.5104",
      "graphql": "/graphql/static-1.85",
      "hs-promise-utils": "/hs-promise-utils/static-1.5824",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5106",
      "icons": "/icons/static-2.672",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-virtualized": "/react-virtualized/static-2.103",
      "rpc-client-utils": "/rpc-client-utils/static-1.4891",
      "salesImages": "/salesImages/static-1.530",
      "timezone-utils": "/timezone-utils/static-2.5475",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10583",
      "ts-schema": "/ts-schema/static-1.4238",
      "hs-locale-management": "/hs-locale-management/static-1.240",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.94",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.863",
      "hubspotter-http": "/hubspotter-http/static-1.4808",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.560",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.1014",
      "quartz-head": "/quartz-head/static-1.1004",
      "quartz-i18n": "/quartz-i18n/static-1.1014",
      "quartz-routing": "/quartz-routing/static-1.769",
      "quartz-test": "/quartz-test/static-1.1014",
      "quartz-tracking": "/quartz-tracking/static-1.718",
      "quick-fetch": "/quick-fetch/static-1.4076",
      "react-rhumb": "/react-rhumb/static-1.16935",
      "trellis-components": "/trellis-components/static-1.2430",
      "ui-fonts": "/ui-fonts/static-1.972",
      "usage-tracker-container": "/usage-tracker-container/static-1.7576",
      "usage-tracker-core": "/usage-tracker-core/static-1.7436",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4624",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2397",
      "hs-story-utils": "/hs-story-utils/static-1.9655",
      "react-create-root-preference": "/react-create-root-preference/static-1.55",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2411",
      "ui-images": "/ui-images/static-2.1222",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3164",
      "foundations-theming-base": "/foundations-theming-base/static-1.3666",
      "stylex": "/stylex/static-1.37",
      "HubStyle": "/HubStyle/static-2.12017",
      "sassPrefix": "/sassPrefix/static-1.161",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
      "property-translator": "/property-translator/static-1.5622",
      "react-dnd-compat": "/react-dnd-compat/static-1.4844",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9543",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.121",
      "audio-components": "/audio-components/static-1.6248",
      "ContentUtils": "/ContentUtils/static-1.69012",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29705",
      "file-manager-components": "/file-manager-components/static-1.24312",
      "FileManagerImages": "/FileManagerImages/static-1.37463",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1380",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4380",
      "react-colorpicker": "/react-colorpicker/static-2.10436",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "ui-universal-auth": "/ui-universal-auth/static-1.9252",
      "urlinator": "/urlinator/static-1.4762",
      "usage-tracker": "/usage-tracker/static-1.7586",
      "video-components": "/video-components/static-1.14007",
      "video-data-lib": "/video-data-lib/static-1.35663",
      "video-embed": "/video-embed/static-1.36497",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.565",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.301",
      "chirp-fetch": "/chirp-fetch/static-1.2116",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10494",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10492",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5272",
      "web-vitals": "/web-vitals/static-1.9",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1184",
      "tanstack-virtual": "/tanstack-virtual/static-1.35",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.22537",
      "copilot-toolkit": "/copilot-toolkit/static-1.11707",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13260",
      "sanitize": "/sanitize/static-1.4705",
      "sanitize-text": "/sanitize-text/static-1.8377",
      "content-assistance-lib": "/content-assistance-lib/static-1.8106",
      "cms-field-types": "/cms-field-types/static-1.5043",
      "content-icons-ui": "/content-icons-ui/static-1.2296",
      "integrations-lib": "/integrations-lib/static-1.16878",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1524",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9305",
      "video-components-external": "/video-components-external/static-1.12005",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1048",
      "social-insights-client-types": "/social-insights-client-types/static-1.22672",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4390",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5709",
      "magpie-types": "/magpie-types/static-1.5169",
      "simple-logging-lib": "/simple-logging-lib/static-1.3278",
      "atom": "/atom/static-1.5305",
      "avatar-components": "/avatar-components/static-1.2726",
      "reference-resolvers": "/reference-resolvers/static-1.8411",
      "superstore": "/superstore/static-1.4985",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8935",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29177",
      "flux-actions": "/flux-actions/static-1.357",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8157",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14293",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5837",
      "laboratory-lib": "/laboratory-lib/static-3.7380",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8006",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10594",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11375",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10491",
      "unified-auth": "/unified-auth/static-1.766",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.502",
      "breeze-engine-core": "/breeze-engine-core/static-1.802",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.82",
      "navigation-messaging": "/navigation-messaging/static-1.8014",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13048",
      "content-media-compositions": "/content-media-compositions/static-2.17055",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19310",
      "fsm": "/fsm/static-1.3966",
      "reactive-lib": "/reactive-lib/static-1.949",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6811",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3239",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5838",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.314",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.891",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.892",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1027",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.337",
      "slack-ui-library": "/slack-ui-library/static-1.10624",
      "js-cookie": "/js-cookie/static-1.18",
      "react-dlb": "/react-dlb/static-1.84",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3739",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7122",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9952",
      "batch-promise": "/batch-promise/static-1.1773",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3957",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4294",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.241",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4166",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7027",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3851",
      "persist-promise": "/persist-promise/static-1.3930"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27823",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};